import { render, staticRenderFns } from "./BugReporter.vue?vue&type=template&id=0fec27ee"
import script from "./BugReporter.vue?vue&type=script&lang=js"
export * from "./BugReporter.vue?vue&type=script&lang=js"
import style0 from "./BugReporter.vue?vue&type=style&index=0&id=0fec27ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports